<div class="row branch-box">
  <div class="col-md-11">
    <h4><b>{{ 'pages.branchManagementPage.branchManagement' | translate }}</b></h4>
  </div>
</div>
<div class="row">
  <div class="col-md-11">
    <div class="panel panel-default panel-box">
      <div class="panel-heading branch-title">
        <h3 class="panel-title">{{ 'pages.branchManagementPage.branchDetails' | translate }}</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.branchName' | translate }}</label>
              <input class="form-control" [placeholder]="'pages.branchManagementPage.branchNamePlaceholder' | translate" [(ngModel)]="branchDetails.BranchCompanyName" disabled />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.localBranchName' | translate }}</label>
              <input class="form-control" placeholder="" [(ngModel)]="branchDetails.BranchLocalizedDisplayName" (blur)="validateBranchDetails()" />
              <span [innerHtml]="validatorObject.LocalizedName.message" style="color:#dc291e"></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.branchCurrency' | translate }}</label>
              <global-drop-down-list [key]="'key'" [selectedValue]="branchDetails.BranchCurrencyCode" [placeHolder]="'Search'" [ddlContent]="currencies" (selectedVal)="onSelectCurrency($event)"></global-drop-down-list>
              <span [innerHtml]="validatorObject.Currency.message" style="color:#dc291e"></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.vatRegistrationTitle' | translate }}</label>
              <input class="form-control" [(ngModel)]="branchDetails.ReceiptLabelVatTitle" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.vatRegistrationNumber' | translate }}</label>
              <input class="form-control" [(ngModel)]="branchDetails.ReceiptLabelVatValue" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group d-flex align-items-center">
              <label class="label-control mr-3">{{ 'pages.branchManagementPage.PackagingSizePrice' | translate }}</label>
              <div class="d-flex flex-grow-1">
                <div class="mr-2">
                  <label class="sub-label-control">{{ 'pages.branchManagementPage.largelSize' | translate }}</label>
                  <input class="form-control form-control-sm" [(ngModel)]="largePackagingPrice"/>
                </div>
                <div class="mr-2">
                  <label class="sub-label-control">{{ 'pages.branchManagementPage.mediumSize' | translate }}</label>
                  <input class="form-control form-control-sm"  [(ngModel)]="mediumPackagingPrice"/>
                </div>
                <div>
                  <label class="sub-label-control">{{ 'pages.branchManagementPage.smallSize' | translate }}</label>
                  <input class="form-control form-control-sm" [(ngModel)]="smallPackagingPrice"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isMultiCurrenciesVisible">
          <div class="col-md-3">
            <div class="form-group">
              <input type="checkbox" id="chk_isMultiCurrenciesForInbound" [(ngModel)]="isMultiCurrenciesForInbound" />
              <label class="m-1" for="chk_isMultiCurrenciesForInbound">{{ 'pages.branchManagementPage.multiCurrenciesCheckbox' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="checkbox" id="chk_isPhoneOptionalForInbound" [(ngModel)]="isPhoneOptionalForInbound" />
              <label class="m-1" for="chk_isPhoneOptionalForInbound">{{ 'pages.branchManagementPage.phoneOptionalCheckbox' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="checkbox" id="chk_isEmailOptionalForInbound" [(ngModel)]="isEmailOptionalForInbound" />
              <label class="m-1" for="chk_isEmailOptionalForInbound">{{ 'pages.branchManagementPage.emailOptionalCheckbox' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <input type="checkbox" id="chk_AllowAutoCashout" [(ngModel)]="ForceDailyCashout" />
              <label class="m-1" for="chk_AllowAutoCashout">Allow Receipts Auto Cashout</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <input type="checkbox" id="chk_AllowTopazSigPad" [(ngModel)]="AllowTopazSigWeb" />
              <label class="m-1" for="chk_AllowTopazSigPad">Allow Topaz Signature Pad</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-11">
    <div class="panel panel-default panel-box">
      <div class="panel-heading branch-title">
        <h3 class="panel-title" style="text-transform: capitalize;">{{ 'pages.branchManagementPage.branchAddress' | translate }}</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.branchAddress' | translate }}</label>
              <input class="form-control" [placeholder]="'pages.branchManagementPage.branchAddressPlaceholder' | translate" [(ngModel)]="branchDetails.BranchAddress" disabled />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.buildingNumber' | translate }}</label>
              <input class="form-control" placeholder="" disabled />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.zipCode' | translate }}</label>
              <input class="form-control" placeholder="" disabled />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'common.phoneNumber' | translate }}</label>
              <input class="form-control" [placeholder]="'pages.branchManagementPage.phoneNumberPlaceholder' | translate" [(ngModel)]="branchDetails.BranchTelephone" (blur)="resolvePhone(branchDetails.BranchTelephone,'phone')" />
              <span [innerHtml]="validatorObject.Mobile.message" style="color:#dc291e"></span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'pages.branchManagementPage.faxNumber' | translate }}</label>
              <input class="form-control" [placeholder]="'pages.branchManagementPage.faxNumberPlaceholder' | translate" [(ngModel)]="branchDetails.BranchFax" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'common.state' | translate }}</label>
              <div class="inner-addon right-addon">
                <i class="glyphicon armx-sort"></i>
                <input type="text" class="form-control" placeholder="" disabled />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'common.city' | translate }}</label>
              <div class="inner-addon right-addon">
                <i class="glyphicon armx-sort"></i>
                <input type="text" class="form-control" placeholder="" disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="label-control">{{ 'common.country' | translate }}</label>
              <div class="inner-addon right-addon">
                <i class="glyphicon armx-sort"></i>
                <input type="text" class="form-control" [placeholder]="'pages.branchManagementPage.countryPlaceholder' | translate" disabled [(ngModel)]="branchDetails.BranchCompanyCountryName" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- error message for  user Input -->
<div class="row" *ngIf="!validateSaveObject.valid">
  <span [innerHtml]="validateSaveObject.message" style="color:#dc291e"></span>
</div>
<branch-working-hours [BusinessWeek]="BusinessWeek" style="display:none"></branch-working-hours>
<div class="row">
  <div class="col-md-1 pull-right">
    <div class="form-group">
      <button class="btn btn-primary full-width" (click)="updateBranchDetails()">{{ 'common.save' | translate }}</button>
    </div>
  </div>
  <div class="col-md-1 pull-right">
    <div class="form-group">
      <button class="btn btn-default full-width">{{ 'common.cancel' | translate }}</button>
    </div>
  </div>
</div>
